/**
 * Trims string values before performing the 'required' validation on them.
 *
 * We must disable ng-trim on expanding form controls so that the
 * control grows as we add trailing new-lines, but since the 'required'
 * validator doesn't trim strings before checking if they're empty we won't get
 * validation errors for textareas with only whitespace in them, so we need this
 * directive which trims the string values before validating them.
 *
 * Everything except for the `trim()` part is taken from the built-in 'required'
 * validation directive.
 */

angular.module('bribac.validators.requiredWithTrim', [])

  .directive('requiredWithTrim', function() {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function(scope, element, attr, ctrl) {
        if (!ctrl) return;
        attr.required = true; // force truthy in case we are on non input element

        ctrl.$validators.required = function(modelValue, viewValue) {
          var value = typeof viewValue === 'string' ? viewValue.trim() : viewValue
          return !attr.required || !ctrl.$isEmpty(value);
        };

        attr.$observe('required', function() {
          ctrl.$validate();
        });
      }
    }
  })
